import React from "react";
import { Fragment } from "react";
import { useDispatch, useSelector, connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { checkShowModal } from "../../../modules/actions/cancelConfirm.action";

// import List from "../../../assets/icons/List.svg";
// import { collapseSidebar } from "../../../modules/actions/collapseSidebar.action";

function Breadcrumbs(props) {
  const { data } = props;
  const dispatchActions = useDispatch();
  const state = useSelector((state) => state.cancelConfirmReducer);

  // useEffect(() => {
  //   if (notificationIsAllowed) {
  //     dispatchActions(
  //       requestNotifications("/notification-service", {
  //         payload: {
  //           action: "list.notifications",
  //           sortBy: "created_at",
  //           sortDir: DESC.toUpperCase(),
  //           limit: 10,
  //           offset: 0,
  //         },
  //       })
  //     );
  //   }
  // }, [props.me]);

  const handleClick = (item) => {
    if (state.formDirtBool) {
      dispatchActions(checkShowModal(() => props.history.push(item.url)));
    } else {
      props.history.push(item.url);
    }
  };

  return (
    <>
      <div
        className="breadcrumb-header"
        style={{
          margin: "0px 0px 0px 5px",
          width: "calc(100% - 8px)",
        }}
      >
        <div className="left-header">
          <ul className="ml-3">
            {data
              ? data.map((item, index) => (
                  <Fragment key={index}>
                    {item.url ? (
                      <li
                        onClick={() => handleClick(item)}
                        className="active-breadcrumb"
                      >
                        {item.title}
                      </li>
                    ) : (
                      <li>{item.title}</li>
                    )}
                    {index < data.length - 1 ? (
                      <li className="backslash">&gt;</li>
                    ) : (
                      ""
                    )}
                  </Fragment>
                ))
              : ""}
          </ul>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

  export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs)
);
